"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ui_1 = require("@ocean-club/ui");
const utils_1 = require("../../modules/translation/utils");
const utils_2 = require("../../lib/utils");
const LoginModal_1 = __importDefault(require("../LoginModal"));
class SignInPage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleToggleLoginModal = () => {
            const isLoginModalOpen = !this.state.isLoginModalOpen;
            this.setState({ isLoginModalOpen });
        };
        this.getTranslations = () => {
            const { hasTranslations, isConnected } = this.props;
            if (!hasTranslations) {
                return undefined;
            }
            return {
                header: React.createElement(utils_1.T, { id: "@dapps.sign_in.get_started" }),
                error: React.createElement(utils_1.T, { id: "@dapps.sign_in.error" }),
                connect: React.createElement(utils_1.T, { id: "@dapps.sign_in.connect" }),
                connecting: React.createElement(utils_1.T, { id: "@dapps.sign_in.connecting" }),
                connected: React.createElement(utils_1.T, { id: "@dapps.sign_in.connected" }),
                message: isConnected ? (React.createElement(utils_1.T, { id: "@dapps.sign_in.options.connected" })) : utils_2.isMobile() ? (React.createElement(utils_1.T, { id: "@dapps.sign_in.options.mobile", values: {
                        klever_link: (React.createElement("a", { href: "https://klever.io", target: "_blank", rel: "noopener noreferrer" }, "Klever")),
                    } })) : (React.createElement(utils_1.T, { id: "@dapps.sign_in.options.desktop", values: {
                        tronlink_link: (React.createElement("a", { href: "https://tronlink.org", target: "_blank", rel: "noopener noreferrer" }, "TRONLink")),
                        ledger_nano_link: (React.createElement("a", { href: "https://www.ledger.com/", target: "_blank", rel: "noopener noreferrer" }, "Ledger Nano S"))
                    } }))
            };
        };
        this.state = {
            isLoginModalOpen: false
        };
    }
    render() {
        const { center, isConnected, isConnecting, hasError, onConnect } = this.props;
        const { isLoginModalOpen } = this.state;
        return (React.createElement(React.Fragment, null,
            React.createElement(ui_1.SignIn, { center: center, isConnected: isConnected, isConnecting: isConnecting, hasError: hasError, onConnect: this.handleToggleLoginModal, i18n: this.getTranslations() }),
            React.createElement(LoginModal_1.default, { open: isLoginModalOpen, onConnect: onConnect, onClose: this.handleToggleLoginModal })));
    }
}
exports.default = SignInPage;
//# sourceMappingURL=SignInPage.js.map